import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Session } from '@models/session';
import { TranslateModule } from '@ngx-translate/core';
import { ScriptToggleComponent } from '../script-toggle/script-toggle.component';
import { CommonModule } from '@angular/common';
import { AutomatedAttendanceOptionsComponent } from '../automated-attendance-options/automated-attendance-options.component';

@Component({
  selector: 'lv-walk-step-complete',
  templateUrl: 'walk-step-complete.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, TranslateModule, ScriptToggleComponent, AutomatedAttendanceOptionsComponent]
})
export class WalkStepCompleteComponent {
  @Input() session: Session;

  get displayAutomatedAttendanceOptions(): boolean {
    const serviceEnabled = this.session.services.includes('automated_attendance');
    const optionsEnabled = this.session.serviceOptions.automatedAttendance.anythingEnabled;
    return serviceEnabled && optionsEnabled;
  }
}
